/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BonusCompensationMenuUpdateReqVo
 */
export interface BonusCompensationMenuUpdateReqVo {
    /**
     * 用户ID
     * @type {number}
     * @memberof BonusCompensationMenuUpdateReqVo
     */
    userId: number;
    /**
     * 是否显示赠送金流水画面 0 隐藏，1 显示
     * @type {number}
     * @memberof BonusCompensationMenuUpdateReqVo
     */
    showCompensationMenu: number;
}

/**
 * Check if a given object implements the BonusCompensationMenuUpdateReqVo interface.
 */
export function instanceOfBonusCompensationMenuUpdateReqVo(value: object): value is BonusCompensationMenuUpdateReqVo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('showCompensationMenu' in value) || value['showCompensationMenu'] === undefined) return false;
    return true;
}

export function BonusCompensationMenuUpdateReqVoFromJSON(json: any): BonusCompensationMenuUpdateReqVo {
    return BonusCompensationMenuUpdateReqVoFromJSONTyped(json, false);
}

export function BonusCompensationMenuUpdateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusCompensationMenuUpdateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'showCompensationMenu': json['showCompensationMenu'],
    };
}

export function BonusCompensationMenuUpdateReqVoToJSON(json: any): BonusCompensationMenuUpdateReqVo {
    return BonusCompensationMenuUpdateReqVoToJSONTyped(json, false);
}

export function BonusCompensationMenuUpdateReqVoToJSONTyped(value?: BonusCompensationMenuUpdateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'showCompensationMenu': value['showCompensationMenu'],
    };
}

